// Play Types
export const PLAY_TYPES = {
  MATCH: 'match',
  PRACTICE: 'practice'
};

// Play Formats
export const PLAY_FORMATS = {
  SINGLES: 'singles',
  DOUBLES: 'doubles'
};

// Group Types
export const GROUP_TYPES = {
  MALE: 'male',
  FEMALE: 'female',
  MIXED: 'mixed'
};

// Group Visibility
export const GROUP_VISIBILITY = {
  PUBLIC: 'public',
  PRIVATE: 'private'
};

// Skill Levels (NTRP Ratings)
export const SKILL_LEVELS = {
  RATING_2_5: '2.5',
  RATING_3_0: '3.0',
  RATING_3_5: '3.5',
  RATING_4_0: '4.0',
  RATING_4_5: '4.5'
};

// UI Constants
export const COLORS = {
  PRIMARY: '#0066FF',
  PRIMARY_HOVER: '#0052CC',
  TENNIS_GREEN: '#90B77D',
  TENNIS_COURT: '#2B4865'
};

// Form Validation
export const MAX_DAYS_AHEAD = 30;
export const GROUP_NAME_MAX_LENGTH = 50;
export const GROUP_DESCRIPTION_MAX_LENGTH = 500;

// PropTypes (for documentation)
export const PROP_TYPES = {
  GROUP_FORM: {
    name: 'string',
    description: 'string',
    visibility: Object.values(GROUP_VISIBILITY),
    gender: Object.values(GROUP_TYPES)
  },
  PLAY_FORM: {
    group: 'string',
    typeOfPlay: Object.values(PLAY_TYPES),
    format: Object.values(PLAY_FORMATS),
    date: 'string',
    time: 'string',
    location: 'string',
    comments: 'string'
  }
}; 